import { render, staticRenderFns } from "./PickLanguage.vue?vue&type=template&id=61803d99&"
import script from "./PickLanguage.vue?vue&type=script&lang=js&"
export * from "./PickLanguage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports